export const centerMemberRoles = Object.freeze([{
  label: 'Center chief',
  value: 'CENTER_CHIEF'
}, {
  label: 'Deputy center chief',
  value: 'DEPUTY_CENTER_CHIEF'
}]);